import { Datagrid, DateField, List, NumberField, ReferenceInput, SelectInput , TextField } from "react-admin";

const postFilters = [
    <ReferenceInput
        label="S3 Bucket"
        source="bucketName"
        reference="aws/buckets"
    >
        <SelectInput 
        optionText="Name" 
        optionValue="Name"
        />
    </ReferenceInput>,
];

export const AwsFileList = props => (
    <>
    <List filters={postFilters}  {...props}  >
        <Datagrid rowClick="edit">
            <TextField source="Key" />
            <DateField source="LastModified" />
            <TextField source="ETag" />
            <NumberField source="Size" />
            <TextField source="StorageClass" />
            <TextField source="Owner.DisplayName" />
            {/* <ShowButton ></ShowButton> */}
        </Datagrid>
    </List>
    </>
);